import { api, API_BASE } from "../lib/api";

export const list = () => api.get("/shares").then((r) => r.data);

export const get = (id) => api.get(`/shares/${id}`).then((r) => r.data);

export const create = (payload) => api.post("/shares", payload).then((r) => r.data);

export const revoke = (id) => api.post(`/shares/${id}/revoke`).then((r) => r.data);

export const remove = (id) => api.delete(`/shares/${id}`).then((r) => r.data);

export const updateOpens = (id, payload) =>
  api.patch(`/shares/${id}/opens`, payload).then((r) => r.data);

export const updateExpiration = (id, payload) =>
  api.patch(`/shares/${id}/expiration`, payload).then((r) => r.data);

export const adminStats = (filters = {}) =>
  api.get("/admin/share-stats", { params: filters }).then((r) => r.data);

export const statsPage = (filters = {}) =>
  api.get("/share-stats/page", { params: filters }).then((r) => r.data);

export const statsSummary = (filters = {}) =>
  api.get("/share-stats/summary", { params: filters }).then((r) => r.data);

export const hotStale = () =>
  api.get("/dashboard/hot-stale-prospects").then((r) => r.data);

export const publicUrl = (token) => `/share/${token}`;
export const publicApiUrl = (token) => `${API_BASE}/public/shares/${token}`;

// Share-reopen requests workflow (auth)
export const listRequests = (status) =>
  api.get("/share-requests", { params: status ? { status } : {} }).then((r) => r.data);

export const approveRequest = (id, payload) =>
  api.post(`/share-requests/${id}/approve`, payload).then((r) => r.data);

export const rejectRequest = (id) =>
  api.post(`/share-requests/${id}/reject`).then((r) => r.data);

// Exchange authentifié : messages + rendez-vous.
export const listExchangeMessages = (shareId) =>
  api.get(`/shares/${shareId}/exchange/messages`).then((r) => r.data);

export const sendExchangeMessage = (shareId, payload) =>
  api.post(`/shares/${shareId}/exchange/messages`, payload).then((r) => r.data);

export const listExchangeMeetings = (shareId) =>
  api.get(`/shares/${shareId}/exchange/meetings`).then((r) => r.data);

export const proposeExchangeMeetings = (shareId, payload) =>
  api.post(`/shares/${shareId}/exchange/meetings`, payload).then((r) => r.data);

// ACTA_SHARE_MEETING_INTERNAL_SELECT_API_V1
export const selectExchangeMeeting = (shareId, meetingId, payload) =>
  api
    .post(`/shares/${shareId}/exchange/meetings/${meetingId}/select`, payload)
    .then((r) => r.data);

export const updateExchangeMeeting = (shareId, meetingId, payload) =>
  api.patch(`/shares/${shareId}/exchange/meetings/${meetingId}`, payload).then((r) => r.data);

// ACTA_MEETING_INTERNAL_DECISION_API_V1
export const refuseExchangeMeeting = (
  shareId,
  meetingId
) =>
  api
    .post(
      `/shares/${shareId}/exchange/meetings/${meetingId}/refuse`
    )
    .then((r) => r.data);

export const counterExchangeMeeting = (
  shareId,
  meetingId,
  payload
) =>
  api
    .post(
      `/shares/${shareId}/exchange/meetings/${meetingId}/counter`,
      payload
    )
    .then((r) => r.data);

export const confirmExchangeMeeting = (
  shareId,
  meetingId
) =>
  api
    .post(
      `/shares/${shareId}/exchange/meetings/${meetingId}/confirm`
    )
    .then((r) => r.data);

// ACTA_AGENDA_CONFIRMED_MEETING_UPDATE_API_V1
export const updateConfirmedExchangeMeeting = (shareId, meetingId, payload) =>
  api.patch(`/shares/${shareId}/exchange/meetings/${meetingId}/confirmed`, payload).then((r) => r.data);

export const deleteExchangeMeeting = (shareId, meetingId) =>
  api.delete(`/shares/${shareId}/exchange/meetings/${meetingId}`).then((r) => r.data);

// ACTA_AUTH_EXCHANGE_READ_API_V2
export const markExchangeMessagesRead = (shareId) =>
  api
    .post(`/shares/${shareId}/exchange/messages/read`)
    .then((r) => r.data);

export const markExchangeMeetingsRead = (shareId) =>
  api
    .post(`/shares/${shareId}/exchange/meetings/read`)
    .then((r) => r.data);
